// extracted by mini-css-extract-plugin
module.exports = {"airpay":"airpayIntegration_airpay__2QwaH","failurePage":"airpayIntegration_failurePage__3AQer"};